module.exports = __webpack_public_path__ + "img/2.43129e89.jpg";